'use strict';

angular.module('app').filter('timezone', function () {
  return function (input, notUTC) {
    if (!input) {
      return undefined;
    }

    if (notUTC || input.indexOf('T') === -1) {
      return moment(input).format('YYYY-MM-DD');
    }

    return moment(input).utc().format('YYYY-MM-DD');
  };
});
